"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FAQ() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const faqs = [{
    id: 1,
    question: "What age groups do you teach?",
    answer: "We offer classical ballet training for students of all ages, from young beginners to advanced dancers. Our curriculum-based programs are structured to support each developmental stage, ensuring proper technique and artistic growth at every level."
  }, {
    id: 2,
    question: "What makes your ballet school international?",
    answer: "Live Entertainment, LLC is recognized as a Professional Ballet School International due to our commitment to world-class instruction, cultural exchange, and adherence to internationally recognized ballet curricula. Our experienced faculty brings diverse expertise from leading institutions worldwide."
  }, {
    id: 3,
    question: "Do you focus on performance or education?",
    answer: "Our primary focus is on fine arts education and classical ballet training. We emphasize discipline, technique, and artistic development through a structured, curriculum-based approach. While performance opportunities may arise, our core mission is educational excellence."
  }, {
    id: 4,
    question: "What should students expect in their classes?",
    answer: "Students can expect a rigorous yet supportive environment where they refine their craft under experienced faculty. Classes emphasize proper technique, discipline, musicality, and artistic expression, all within a professional setting that fosters both individual growth and a sense of community."
  }, {
    id: 5,
    question: "How do I enroll or schedule a trial class?",
    answer: "To enroll or schedule a trial class, please contact us at info@liveentertainmentllc.com or call 8182980589. Our team will be happy to discuss your goals, answer any questions, and guide you through the enrollment process."
  }, {
    id: 6,
    question: "Where is the school located?",
    answer: "Live Entertainment, LLC is located at 9761 Samoa Ave, Tujunga, CA 91042. We serve students throughout the Tujunga area and beyond, welcoming dancers who are committed to pursuing excellence in classical ballet."
  }];
  return <section id="faq" className="bg-light-background text-foreground-light py-16 px-6 sm:px-8 lg:px-12">
			<div className="mx-auto max-w-3xl">
				<div ref={ref} className={`transition-all duration-[350ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`}>
					<h2 className="font-display text-4xl sm:text-5xl font-bold text-center mb-4 text-primary">
						Frequently Asked Questions
					</h2>
					<p className="text-center text-base sm:text-lg text-foreground-light/80 mb-12 max-w-2xl mx-auto">
						Have questions about our programs, enrollment, or approach to classical ballet training? Find answers below.
					</p>
				</div>

				<Accordion type="single" collapsible className="space-y-4">
					{faqs.map((faq, i) => {
          const itemRef = useRevealOnScroll({
            threshold: 0.2,
            once: true
          });
          return <div key={faq.id} data-index={i} ref={itemRef.ref} className={`transition-all duration-[350ms] ease-out ${itemRef.isVisible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`} style={{
            transitionDelay: `${i * 80}ms`
          }}>
								<AccordionItem value={`item-${faq.id}`} className="border border-border rounded-lg px-6 bg-muted-light-background shadow-soft hover:shadow-medium transition-shadow duration-[250ms]">
									<AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-foreground-light hover:text-primary transition-colors duration-[150ms]">
										{faq.question}
									</AccordionTrigger>
									<AccordionContent className="text-sm sm:text-base text-foreground-light/80 leading-relaxed">
										{faq.answer}
									</AccordionContent>
								</AccordionItem>
							</div>;
        })}
				</Accordion>
			</div>
		</section>;
}